import * as ActionTypes from '../../constants/ActionTypes';
import API from '../../helpers/api';

export function getApplicationInfo(id) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_APPLICATION_INFO_REQUEST,
			payload: { loading: true }
		});

		const response = await API.application_info.getApplicationInfo(id);

		if(response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_APPLICATION_INFO_ERROR,
				payload: {
					meta: response.meta,
					loading: false
				}
			});
			return;
		}

		const { application_info: applicationInfo } = response.data;

		dispatch({
			type: ActionTypes.GET_APPLICATION_INFO_SUCCESS,
			payload: {
				applicationInfo,
				loading: false
			}
		});
	};
}

export function onApplicationInfoSubmit({ id, fields }) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.SUBMIT_APPLICATION_INFO_REQUEST,
			payload: { loadingSubmit: true }
		});

		const body = {
			application_info: {
				...fields
			}
		};
		
		let response;
		if (id) {
			response = await API.application_info.updateApplicationInfo(id, body);
		} else {
			response = await API.application_info.createApplicationInfo(body);
		}

		if(response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.SUBMIT_APPLICATION_INFO_ERROR,
				payload: {
					meta: response.meta,
					loadingSubmit: false
				}
			});
			return;
		}

		const { application_info: newApplicationInfo } = response.data;

		dispatch({
			type: ActionTypes.SUBMIT_APPLICATION_INFO_SUCCESS,
			payload: {
				applicationInfo: newApplicationInfo,
				loadingSubmit: false,
				meta: response.meta
			}
		});
	};
}

export function resetApplicationInfoPage() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_APPLICATION_INFO_PAGE
		});
	};
}

export function resetApplicationInfoMeta() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_APPLICATION_INFO_META
		});
	};
}